
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEco as ObiEcoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-eco.js';
 
 
 

 
 export const ObiEco = createComponent({
   react: React,
   tagName: 'obi-eco',
   elementClass: ObiEcoElement,
   events: {
     
   }
  });
 
 